import React, { useState } from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { acceptConsent } from '../../services/chatApi';

export function ConsentScreen({ onAccepted }: { onAccepted: () => void }) {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const [pending, setPending] = useState(false);

  const handleAccept = async () => {
    if (pending) return;
    setPending(true);
    try {
      await acceptConsent();
      onAccepted();
    } catch {
      setPending(false);
    }
  };

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.surface }]}>
      <Text style={[styles.title, { color: theme.colors.text }]}>{t('chat.consent.title')}</Text>
      <Text style={[styles.body, { color: theme.colors.text }]}>{t('chat.consent.body')}</Text>
      <Pressable
        accessibilityRole="button"
        onPress={handleAccept}
        disabled={pending}
        style={[
          styles.btn,
          { backgroundColor: theme.colors.primary },
          pending && styles.btnDisabled,
        ]}
      >
        <Text style={{ color: theme.colors.textInverse }}>
          {pending ? '…' : t('chat.consent.accept')}
        </Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, padding: 24, justifyContent: 'center' },
  title: { fontSize: 22, fontWeight: '700', marginBottom: 16 },
  body: { fontSize: 15, lineHeight: 23, marginBottom: 32 },
  btn: { padding: 16, borderRadius: 12, alignItems: 'center' },
  btnDisabled: { opacity: 0.6 },
});
